import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Icon from '../../../components/icon'
import PasswordInput from '../../../components/password-input'

/**
 * Password re-entry required before changing the account email address.
 * Save stays disabled until a password is typed — guard restored from the
 * pre-redesign page (PR #547 review).
 */
export default function PasswordConfirmModal({
  show,
  onHide,
  value,
  onChange,
  onSave,
}) {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Icon name="lock-alt" className="me-2" />
          {t('users.edit.email_verify_password_title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label htmlFor="emailPasswordConfirmation" className="form-label">
          {t('users.edit.password_confirmation')}
        </label>
        <PasswordInput
          id="emailPasswordConfirmation"
          onChange={onChange}
          showPasswordToggle
          value={value || ''}
          autofocus={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('event_card.close')}
        </Button>
        <Button variant="primary" onClick={onSave} disabled={!value}>
          {t('users.edit.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

PasswordConfirmModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}
